import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function TailorShopDetails() {
    const { id } = useParams()

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
    const [isEquipentModalOpen, setIsEquipmentModalOpen] = useState(false)
    const [isEditEquipentModalOpen, setIsEditEquipmentModalOpen] = useState(false)

    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Tailor/item/getalltailoritembytailorid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])

    const [monthData, setMonthData] = useState([])

    const MonthDataFetch = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/Common/months`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setMonthData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        MonthDataFetch()
    }, [])

    const [juiceCenterData, setJuiceCenterData] = useState({
        tailorId: id,
        year: 0,
        month: 0,
        name: "",
        quantity: 0,
        price: 0,
        totalAmount: 0,
        latitude: "",
        longitude: ""

    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setJuiceCenterData({ ...juiceCenterData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Tailor/item`, juiceCenterData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something Went wrong")
            return error.message
        }
    }


    const calculateMonthlyRevenue = () => {
        const result = juiceCenterData.quantity * juiceCenterData.price
        setJuiceCenterData(prev => ({
            ...prev,
            totalAmount: result
        }))
    };

    React.useEffect(() => {
        calculateMonthlyRevenue();
    }, [juiceCenterData.quantity, juiceCenterData.price]);


    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Tailor/item/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }

            })
            setJuiceCenterData(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }


    //update Method

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Tailor/item/${id}`, juiceCenterData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Successfully Updated")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }

    const columns = [
        {
            title: "Product",
            dataIndex: "name",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Month",
            dataIndex: "month",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Price",
            dataIndex: "price",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
    ];



    // Tailor Equipments All Methods


    const [getDeptSingleData, setGetDeptSingleData] = useState([])

    const getDeptSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Tailor/equipment/getalltailorequipmentbytailorid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setGetDeptSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => { getDeptSingleUser() }, [])


    const [tailorEquipmentData, setTailorEquipmentData] = useState({
        tailorId: id,
        name: "",
        price: 0,
        life: 0,
        depriciation: 0,
        depriciationMonthly: 0,
        scrapValue: 0,
        netValue: 0,
        latitude: "",
        longitude: ""
    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                const { latitude, longitude } = position.coords
                setTailorEquipmentData(prev => ({ ...prev, latitude: latitude.toString(), longitude: longitude.toString() }))
            })
        } else {
            console.log("Geolocation is not supported by this browser.")
        }
    }, [])

    const handleDeptSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Tailor/equipment`, tailorEquipmentData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleAllCancel()
                getDeptSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }

    // Equipments Calculation

    const CalculateScrapValueNetValue = () => {
        const result = (tailorEquipmentData.price * 0.15) || 0;
        const netValue = (tailorEquipmentData.price - result) || 0;
        const deptPerAnnum = netValue / tailorEquipmentData.life
        const DeptPerMonth = deptPerAnnum / 12
        setTailorEquipmentData(prev => ({
            ...prev,
            scrapValue: result,
            netValue: netValue,
            depriciation: deptPerAnnum,
            depriciationMonthly: DeptPerMonth
        }))
    };

    useEffect(() => { CalculateScrapValueNetValue() }, [tailorEquipmentData.price, tailorEquipmentData.life])

    const col = [
        {
            title: "Equipment",
            dataIndex: "name",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Cost",
            dataIndex: "price",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Life",
            dataIndex: "life",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Scrap Value",
            dataIndex: "scrapValue",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Dep./Year",
            dataIndex: "depriciation",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Dep./Month",
            dataIndex: "depriciationMonthly",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Net Value",
            dataIndex: "netValue",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        type="primary"
                        onClick={() => handleEquipmentClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
    ];

    const calculateDeptPerMOnth = () => {
        const result = tailorEquipmentData.purchase * tailorEquipmentData.quantity
        setTailorEquipmentData(prev => ({
            ...prev,
            depression: result / tailorEquipmentData.durability
        }))
    };

    useEffect(() => {
        calculateDeptPerMOnth()
    }, [tailorEquipmentData.purchase, tailorEquipmentData.durability, tailorEquipmentData.quantity])


    async function handleCancel() {
        setJuiceCenterData({
            ...juiceCenterData,
            tailorId: id,
            year: 0,
            month: 0,
            name: "",
            quantity: 0,
            price: 0,
            totalAmount: 0,
        })
        setIsEditModalOpen(false)
        setIsModalOpen(false);
    }


    async function handleAllCancel() {
        setTailorEquipmentData({
            ...tailorEquipmentData,
            tailorId: id,
            name: "",
            price: 0,
            life: 0,
            depriciation: 0,
            depriciationMonthly: 0,
            scrapValue: 0,
            netValue: 0,
        })
        setIsEquipmentModalOpen(false)
        setIsEditEquipmentModalOpen(false)
    }

    // Updated Method for 

    const handleEquipmentClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Tailor/equipment/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setTailorEquipmentData(response.data.data)
            setIsEditEquipmentModalOpen(true)
        } catch (error) {
            return error.message
        }
    }

    // Upodated Method


    const handlevalueChange = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Tailor/equipment/${id}`, tailorEquipmentData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Successfully updated")
                handleAllCancel()
                getDeptSingleUser()

            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }




    return (

        <>



            <div className="page-wrapper">
                <div className="content container-fluid">


                    {/* Tabs */}

                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Assesment</button>
                            <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Equipment</button>

                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">

                        {/* Assesments Tab */}
                        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                            <div className="row">
                                <div className="col-12 d-flex align-items-center justify-content-between">
                                    <h3 className="mb-0">Tailor Shop</h3>
                                    <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Product</button>
                                </div>
                            </div>

                            <div className="row mt-4">
                                <div className="col-12 mx-auto">
                                    <Table
                                        className="table-striped"
                                        style={{ overflowX: "auto" }}
                                        columns={columns}
                                        dataSource={singleData}
                                        rowKey={(record) => record.id}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <Modal
                        title={<h4>Product Assesment</h4>}
                        open={isModalOpen}
                        onOk={() => setIsModalOpen(false)}
                        onCancel={() => handleCancel()}
                        footer={[
                            <div className='d-flex justify-content-between align-items-center'>
                                <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                                <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>
                            </div>
                        ]}
                        width={600}
                        mask={false}
                        maskClosable={false}
                        closeIcon={<span style={{ color: "red" }}>X</span>}
                    >
                        <div className="modal-body mt-5">
                            <form>
                                <Divider>Add Product Assesment</Divider>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <select className="form-control" value={juiceCenterData.month} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, month: e.target.value })}>
                                                <option value="">Select Month</option>
                                                {monthData && monthData.length > 0 && monthData.map((res) => (
                                                    <option value={res.id}>{res.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <select className="form-control" value={juiceCenterData.year} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, year: e.target.value })}>
                                                <option value="">Select Year</option>
                                                <option value={2023}>2023</option>
                                                <option value={2024}>2024</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Product Name:
                                            </label>
                                            <input className="form-control" type="text" placeholder="Product Name" value={juiceCenterData.name} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, name: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Quantity:
                                            </label>
                                            <input className="form-control" type="number" placeholder="Quantity" value={juiceCenterData.quantity} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, quantity: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Rate per Pcs:
                                            </label>
                                            <input className="form-control" type="text" placeholder="Rate per Pcs" value={juiceCenterData.price} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, price: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row my-3">
                                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                        <p className="mb-0">Total Amount: </p>
                                        <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {juiceCenterData.totalAmount.toFixed(2)}</span>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </Modal>

                    {/* Edit modal */}

                    <Modal
                        title={<h4>Product Assesment</h4>}
                        open={isEditModalOpen}
                        onOk={() => setIsEditModalOpen(false)}
                        onCancel={() => handleCancel()}
                        footer={[
                            <div className='d-flex justify-content-between align-items-center'>
                                <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                                <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(juiceCenterData.id)}>Submit</button>
                            </div>
                        ]}
                        width={600}
                        mask={false}
                        maskClosable={false}
                        closeIcon={<span style={{ color: "red" }}>X</span>}
                    >
                        <div className="modal-body mt-5">
                            <form>
                                <Divider>Add Product Assesment</Divider>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <select className="form-control" value={juiceCenterData.month} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, month: e.target.value })}>
                                                {monthData && monthData.length > 0 && monthData.map((res) => (
                                                    <option value={res.id}>{res.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <select className="form-control" value={juiceCenterData.year} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, year: e.target.value })}>
                                                <option value={2023}>2023</option>
                                                <option value={2024}>2024</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Product Name:
                                            </label>
                                            <input className="form-control" type="text" placeholder="Product Name" value={juiceCenterData.name} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, name: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Quantity:
                                            </label>
                                            <input className="form-control" type="number" placeholder="Quantity" value={juiceCenterData.quantity} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, quantity: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">
                                                Rate per Pcs:
                                            </label>
                                            <input className="form-control" type="text" placeholder="Rate per Pcs" value={juiceCenterData.price} onChange={(e) => setJuiceCenterData({ ...juiceCenterData, price: e.target.value })} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row my-3">
                                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                        <p className="mb-0">Total Amount: </p>
                                        <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {juiceCenterData.totalAmount.toFixed(2)}</span>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </Modal>

                </div>

                {/* Equipements Tab */}
                <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">

                    <div className="content container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex align-items-center justify-content-between">
                                <h3 className="mb-0">Tailor Assesments </h3>
                                <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsEquipmentModalOpen(true)}>Equipment Assests</button>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12 mx-auto">
                                <Table
                                    className="table-striped"
                                    style={{ overflowX: "auto" }}
                                    columns={col}
                                    dataSource={getDeptSingleData}
                                    rowKey={(record) => record.id}
                                />
                            </div>
                        </div>

                        <Modal
                            title={<h4>Tent House</h4>}
                            open={isEquipentModalOpen}
                            onOk={() => setIsEquipmentModalOpen(false)}
                            onCancel={() => handleAllCancel()}
                            footer={[
                                <div className='d-flex justify-content-between align-items-center'>
                                    <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleAllCancel}>Cancel</button>,
                                    <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleDeptSubmit}>Submit</button>
                                </div>
                            ]}
                            width={600}
                            masked={false}
                            maskClosable={false}
                            closeIcon={<span style={{ color: "red" }}>X</span>}
                        >
                            <div className="modal-body mt-5">
                                <form>
                                    <Divider>Tent House</Divider>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="input-block mb-3">
                                                <label className="col-form-label">Equipment Name:</label>
                                                <input className="form-control" type="text" placeholder="item name" value={tailorEquipmentData.name} onChange={(e) => setTailorEquipmentData({ ...tailorEquipmentData, name: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="input-block mb-3">
                                                <label className="col-form-label">Cost of Equipment:</label>
                                                <input className="form-control" type="number" placeholder="Enter Purchase Cost" value={tailorEquipmentData.price} onChange={(e) => setTailorEquipmentData({ ...tailorEquipmentData, price: e.target.value })} />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-sm-12">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">Life of Equipment:</label>
                                            <input className="form-control" type="text" placeholder="Quantity" value={tailorEquipmentData.life} onChange={(e) => setTailorEquipmentData({ ...tailorEquipmentData, life: e.target.value })} />
                                        </div>
                                    </div>

                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Scrap Value @15%: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.scrapValue).toFixed(2)}</span>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Net Value: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.netValue).toFixed(2)}</span>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Depriciation Per Annum: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.depriciation).toFixed(2)}</span>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Depriciation Per Month: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.depriciationMonthly).toFixed(2)}</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Modal>
                        {/* </div> */}

                        {/* Edit Modal */}

                        <Modal
                            title={<h4>Tent House</h4>}
                            open={isEditEquipentModalOpen}
                            onOk={() => setIsEditEquipmentModalOpen(false)}
                            onCancel={() => handleAllCancel()}
                            footer={[
                                <div className='d-flex justify-content-between align-items-center'>
                                    <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleAllCancel}>Cancel</button>,
                                    <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handlevalueChange(tailorEquipmentData.id)}>Update</button>
                                </div>
                            ]}
                            width={600}
                            masked={false}
                            maskClosable={false}
                            closeIcon={<span style={{ color: "red" }}>X</span>}
                        >
                            <div className="modal-body mt-5">
                                <form>
                                    <Divider>Tent House</Divider>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="input-block mb-3">
                                                <label className="col-form-label">Equipment Name:</label>
                                                <input className="form-control" type="text" placeholder="item name" value={tailorEquipmentData.name} onChange={(e) => setTailorEquipmentData({ ...tailorEquipmentData, name: e.target.value })} />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="input-block mb-3">
                                                <label className="col-form-label">Cost of Equipment:</label>
                                                <input className="form-control" type="number" placeholder="Enter Purchase Cost" value={tailorEquipmentData.price} onChange={(e) => setTailorEquipmentData({ ...tailorEquipmentData, price: e.target.value })} />
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-sm-12">
                                        <div className="input-block mb-3">
                                            <label className="col-form-label">Life of Equipment:</label>
                                            <input className="form-control" type="text" placeholder="Quantity" value={tailorEquipmentData.life} onChange={(e) => setTailorEquipmentData({ ...tailorEquipmentData, life: e.target.value })} />
                                        </div>
                                    </div>

                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Scrap Value @15%: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.scrapValue).toFixed(2)}</span>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Net Value: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.netValue).toFixed(2)}</span>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Depriciation Per Annum: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.depriciation).toFixed(2)}</span>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                            <p className="mb-0">Depriciation Per Month: </p>
                                            <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {Number(tailorEquipmentData.depriciationMonthly).toFixed(2)}</span>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Modal>


                    </div>

                </div>

            </div>
        </>
    )
}

export default TailorShopDetails
